import { X } from "react-feather";
import {
  ACCESS_TYPES,
  TIME_TYPES,
  SOLVER_TYPES,
  COMPUTE_TYPES,
} from "./AppEnums";

export const MODELER_ACCESS_TYPE_NAMES = {
  Public: "public",
  Private: "private",
  Shared: "shared",
  Favorite: "favorite",
};
export const TIME_TYPE_NAMES = {
  All: "all",
  Week: "week",
  Month: "month",
  Year: "year",
};
export const SOLVER_TYPE_NAMES = {
  OPENFOAM: "openfoam",
  GERRIS: "gerris",
  SU2: "su2",
};
export const COMPUTE_INSTANCE_TYPE_NAMES = {
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large",
};
export const MODELER_ACCESS_TYPES = {
  [MODELER_ACCESS_TYPE_NAMES.Public]: ACCESS_TYPES.PUBLIC,
  [MODELER_ACCESS_TYPE_NAMES.Private]: ACCESS_TYPES.PRIVATE,
  [MODELER_ACCESS_TYPE_NAMES.Shared]: "UNKNOWN",
  [MODELER_ACCESS_TYPE_NAMES.Favorite]: "UNKNOWN",
};

export const TIME_FILTER_TYPES = {
  [TIME_TYPE_NAMES.All]: TIME_TYPES.ALL,
  [TIME_TYPE_NAMES.Private]: TIME_TYPES.WEEK,
  [TIME_TYPE_NAMES.Month]: TIME_TYPES.MONTH,
  [TIME_TYPE_NAMES.Year]: TIME_TYPES.YEAR,
};

export const SOLVER_TYPES_MAP = {
  [SOLVER_TYPE_NAMES.OPENFOAM]: SOLVER_TYPES.OPENFOAM,
  [SOLVER_TYPE_NAMES.GERRIS]: SOLVER_TYPES.GERRIS,
  [SOLVER_TYPE_NAMES.SU2]: SOLVER_TYPES.SU2,
};

export const COMPUTE_INSTANCE_TYPES = {
  [COMPUTE_INSTANCE_TYPE_NAMES.SMALL]: COMPUTE_TYPES.SMALL,
  [COMPUTE_INSTANCE_TYPE_NAMES.MEDIUM]: COMPUTE_TYPES.MEDIUM,
  [COMPUTE_INSTANCE_TYPE_NAMES.LARGE]: COMPUTE_TYPES.LARGE,
};
export const COMPUTE_INSTANCE_TYPE_LIST = [
  { label: "Small", id: "SMALL" },
  { label: "Medium", id: "MEDIUM" },
  { label: "Large", id: "LARGE" },
  // { label: "OpenLB", id: "OPENLB" },
];

export const MODELRUN_TABLE_RUN_NAME = "runName";
export const MODELRUN_TABLE_RUN_NOTES = "runNotes";
export const MODELRUN_TABLE_RUN_STATUS = "runStatus";
export const MODELRUN_TABLE_RUN_TYPE = "runType";
export const MODELRUN_TABLE_RUN_CREATEDDATE = "createdAt";

export const MODELRUNTASK_TABLE_ID = "id";
export const MODELRUNTASK_TABLE_STATUS = "lastStatus";
export const MODELRUNTASK_TABLE_DESIRED_STATUS = "desiredStatus";
export const MODELRUNTASK_TABLE_CREATEDDATE = "createdAt";
